// src/services/questionService.js
import { supabase } from "../supabaseClient";
import { MY_BACKEND_URL } from "../supabaseClient";


// src/Components/YourComponent/livekitService.js (or wherever this file is)


/**
 * Fetches questions from your backend.
 * @param {string[]} sourceIds - Array of Source IDs (e.g. ['uuid-1', 'uuid-2'])
 * @param {string} difficulty - 'easy', 'medium', or 'hard'
 * @param {number} numQuestions - Total questions needed (default 15)
 */
export const fetchQuestions = async (sourceIds, difficulty, numQuestions, title) => {
    console.log("detaisls of fetch:", sourceIds, difficulty, numQuestions);
  try {
      const { data: { session } } = await supabase.auth.getSession();
    
      if (!session || !session.user) {
        throw new Error("You must be logged In.");
      }
    
      // 2. Get the Access Token (this replaces getIdToken())
    const accessToken = session.access_token;

    const response = await fetch(`${MY_BACKEND_URL}/api/get-questions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Send Supabase Token
      },
      body: JSON.stringify({
        source_ids: sourceIds,
        difficulty: difficulty,
        title: title,
        num_questions: numQuestions
      }),
    });
    console.log("result of fetch:", response);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to fetch questions');
    }

    const result = await response.json();
    
    // CHANGE 3: Return object with both pieces of data
    return {
      questions: result.data,
      testId: result.test_id
    };

  } catch (error) {
    console.error("Question Fetch Error:", error);
    throw error;
  }
};